export const CreditCardAmexLogoIcon = ({
  width = 56,
  height = 37,
  title = "American Express Payment",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 57 36"
      role="img"
      aria-label="American Express"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#0071CE"
        d="m51.8 32-2.5-2.8-2.6 2.8H30.6V19.1h-5.2l6.4-14.5H38l2.2 5v-5h7.7l1.3 3.8 1.3-3.8h5.9V2.4C56.4 1.1 55.3 0 54 0H2.4C1.1 0 0 1.1 0 2.4v31.2C0 34.9 1.1 36 2.4 36h51.7c1.3 0 2.4-1.1 2.4-2.4V32z"></path>
      <path
        fill="#0071CE"
        d="M52.5 30.5h4l-5.3-5.7 5.3-5.5h-3.9l-3.4 3.6-3.2-3.6h-4.1l5.3 5.6-5.3 5.6h3.9l3.4-3.6zM35.4 27.9v-1.7h6.3v-2.6h-6.3v-1.7h6.5v-2.6h-9.6v11.2h9.6v-2.6zM53.5 17.6h3V6.3l-4.7.1-2.5 7-2.6-7h-4.8v11.2H45V9.7l2.9 7.9h2.7l2.9-7.9zM36.9 6.4h-4l-5 11.3h3.4l.9-2.3h5.2l1 2.3h3.5zm-3.6 6.4 1.5-3.7 1.5 3.7z"></path>
      <path fill="#0071CE" d="m53.7 24.5 2.8 3.1.1-6.2z"></path>
    </svg>
  );
};
